<script>
	import InputWrapper from '../InputWrapper.svelte';

	let {
		name,
		group = $bindable(),
		element = $bindable(),
		options = null,
		class: className = '',
		disabled = false,
		required = false,
		error = null,
		valueField = 'value',
		labelField = 'label',
		label = null,
		onchange = null,
		...props
	} = $props();
</script>

<InputWrapper {label} {error} class={className}>
	<fieldset
		class={[
			`
     col-span-full flex h-auto min-h-0 w-full place-items-start content-between
     gap-x-4 border-none
   `,
			{ 'cursor-not-allowed bg-indow-grey-light': disabled },
			{ 'border-indow-red': error },
		]}
		bind:this={element}
		{...props}
	>
		{#each options as option (option[valueField])}
			<label class="mb-3 flex cursor-pointer items-center gap-2">
				<input
					type="radio"
					{name}
					value={option[valueField]}
					{disabled}
					{required}
					bind:group
					{onchange}
					{...props}
					class="
       size-8 border-indow-grey-dark text-indow-blue
       checked:border-indow-blue
     "
				/>
				<span class="text-indow-grey-dark">{option[labelField]}</span>
			</label>
		{/each}
	</fieldset>
</InputWrapper>
